import axios from 'axios'
import { ClientApi } from '../services/clientApi'
import { NuiCallbacks } from '../utils/ClientEvents'
import { Config } from '../utils/config'
import { dedupeRequests } from './dedupeRequests'

export const API_URL = Config.API_URL
export const GAME_SERVICE_API_URL = Config.GAME_SERVICE_API_URL

// Token management functions
export const setTokens = (accessToken: string, refreshToken: string) => {
    console.log('Setting tokens:', { accessToken: accessToken.substring(0, 10) + '...', refreshToken: refreshToken.substring(0, 10) + '...' })
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)
    api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
}

export const clearTokens = () => {
    console.log('Clearing tokens')

    if (ClientApi.isWorking()) {
        ClientApi.send(NuiCallbacks.SAVE_JWT, { accessToken: '', refreshToken: '' })
    }
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    delete api.defaults.headers.common['Authorization']
}

export const redirectToLogin = () => {
    console.log('Redirecting to login')
    clearTokens()
    window.location.href = '/login'
}

// Create axios instance
const api = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})

// Response interceptor for handling errors
api.interceptors.response.use(
    (response) => {
        console.log('Response interceptor:', {
            url: response.config.url,
            status: response.status,
            hasAuthHeader: !!response.config.headers['Authorization']
        })
        return response
    },
    async (error) => {
        console.log('Response error interceptor:', {
            url: error.config?.url,
            status: error.response?.status,
            hasAuthHeader: !!error.config?.headers['Authorization']
        })

        // If unauthorized, redirect to login
        if (error.response?.status === 403 && !error.response?.data?.message) {
            // redirectToLogin();
            return Promise.reject(error)
        }

        return Promise.reject(error)
    }
)

// Request interceptor for adding auth token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        console.log('Request interceptor:', {
            url: config.url,
            method: config.method,
            hasAuthHeader: !!config.headers['Authorization']
        })
        return config
    },
    (error) => {
        console.error('Request interceptor error:', error)
        return Promise.reject(error)
    }
)

dedupeRequests(api)

export default api